var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationInProgressStatusOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.714 13.03h2.572a7.53 7.53 0 00.374 1.538l-2.239 1.294a10.275 10.275 0 01-.707-2.831zm2.1-7.38a10.312 10.312 0 012.029-1.99l1.288 2.233a7.929 7.929 0 00-1.078 1.049L3.814 5.65zm9.398-1.357V1.715c5.11.615 9.074 4.967 9.065 10.25 0 5.7-4.616 10.321-10.31 10.321-1.474 0-2.88-.312-4.15-.872l1.288-2.233a7.728 7.728 0 002.866.548c4.28 0 7.76-3.484 7.76-7.768a7.776 7.776 0 00-6.519-7.668zM10.73 1.715v2.578c-.498.08-.977.21-1.44.38L7.998 2.434a10.24 10.24 0 012.731-.72zM1.756 10.55c.135-.974.404-1.9.787-2.769l2.227 1.29a7.53 7.53 0 00-.43 1.478H1.756zm1.869 7.481l2.23-1.289c.337.426.712.817 1.12 1.167L5.683 20.15a10.442 10.442 0 01-2.058-2.119z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.145 11.777l3.728 3.652 5.636-6.146-1.423-1.602-4.213 4.779-2.302-2.174-1.426 1.49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInProgressStatusOutline);
export default __webpack_public_path__ + "954211e562cff2cd2126f5a6679a1391.svg";
export { ForwardRef as ReactComponent };